import { useState, useEffect, useRef } from 'react';
import './Autocomplete.css';
import { icons } from '../../../../shared/icons';

const Icon = () => {
  return (
    <svg height="20" width="20" viewBox="0 0 20 20" fill="#5d5b5b">
      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
    </svg>
  );
};

const Autocomplete = (props) => {
  const {
    id,
    style,
    disabled,
    handleClick,
    fixedHeight,
    touched,
    setTouched,
    label,
    errorMessage,
    handleClear,
    fixedHeightValue = '230px',
  } = props;
  const [display, setDisplay] = useState(false);
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const wrapperRef = useRef(null);
  useEffect(() => {
    // ako autocomplete bude sporiji zbog ovoga izbaciti ovo pa ispitivati da li su velika ili mala slova key-evi dole u renderu
    let newArray;
    if (props.data) {
      newArray = props.data.map((item) => {
        // eslint-disable-next-line no-restricted-syntax, guard-for-in, prefer-const
        for (let key in item) {
          // eslint-disable-next-line prefer-const
          let upper = key.toLowerCase();
          if (upper !== key) {
            item[upper] = item[key];
            delete item[key];
          }
        }
        return item;
      });
    }

    setOptions(newArray);
    setSearch(props.value);
  }, [props.data, props.value]);

  const handleClickOutside = (event) => {
    const { current: wrap } = wrapperRef;
    if (wrap && !wrap.contains(event.target)) {
      setDisplay(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div>
      <div
        ref={wrapperRef}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          position: 'relative',
          width: 'fit-content',
        }}
      >
        <div>
          {label && (
            <>
              <span className="label" htmlFor={id}>
                {label}
              </span>
              <br />
            </>
          )}
          <input
            id={id}
            className={`input_text ${
              touched && props.value === '' ? 'invalid' : ''
            }`}
            autoComplete="off"
            style={style}
            onClick={() => setDisplay(true)}
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            disabled={disabled}
            onFocus={() => setDisplay(true)}
            onBlur={
              setTouched !== undefined ? () => setTouched(true) : () => {}
            }
          />
          {display && (
            <div
              className="autoContainer"
              style={{
                height: fixedHeight === true ? fixedHeightValue : 'fit-content',
              }}
            >
              {options
                .filter(
                  (item) =>
                    item.vrednost
                      .toString()
                      .toLowerCase()
                      .indexOf(search.toString().toLowerCase()) > -1,
                )
                .map((i) => {
                  return (
                    <div
                      tabIndex="0"
                      className="option"
                      key={i.id}
                      value={i.id}
                      onClick={() => {
                        handleClick(i);
                        setDisplay(false);
                        setSearch(i.vrednost);
                      }}
                    >
                      <span>{i.vrednost}</span>
                    </div>
                  );
                })}
            </div>
          )}
          {search !== '' && (
            <div
              style={{
                position: 'absolute',
                right: '10px',
                top: '25px',
                cursor: 'pointer',
              }}
              onClick={handleClear}
              className={disabled ? 'disabledbutton' : ''}
            >
              {icons.AUTOCOMPLETE_CLOSE}
            </div>
          )}
        </div>
        {search === '' && (
          <div style={{ position: 'absolute', right: '10px', top: '25px' }}>
            <Icon />
          </div>
        )}
      </div>
      {touched && search === '' && (
        <span className="error-message">{errorMessage}</span>
      )}
    </div>
  );
};

export default Autocomplete;
